
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SmallScaleDisplayer extends Vue {
  @Prop() private scale!: string[];

  public hexToRgb(hex: string) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  public dark(i:number):boolean{
    const rgbColor = this.hexToRgb(this.scale[i]);
    let l = 100;
    if(rgbColor!=null){
      l = 0.2126*rgbColor.r  + 0.7152*rgbColor.g + 0.0722*rgbColor.b;
    }

    if(l<50){
      return true;
    }else{
      return false;
    }
  }
}

